
import { motion } from 'framer-motion';

export default function ServicesSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="servicos" className="py-32 bg-[#F4F4F4]">
      <div className="max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-20"
        >
          <span className="font-montserrat text-[#C5A059] text-sm uppercase tracking-[3px]">
            Nossos Serviços
          </span>
          <h2 className="font-cinzel font-semibold text-[#2D2D2D] text-5xl mt-4">
            Soluções Completas em Gramados
          </h2>
        </motion.div>

        <div className="flex gap-10 max-lg:flex-col max-lg:gap-8">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="w-[55%] relative h-[600px] rounded-xl overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.15)] group cursor-pointer max-lg:w-full max-lg:h-[420px]"
          >
            <img
              src="https://readdy.ai/api/search-image?query=modern%20luxury%20backyard%20with%20expansive%20uniform%20green%20artificial%20turf%20grass%20contemporary%20architecture%20minimalist%20design%20premium%20residential%20garden%20clean%20lines%20perfect%20lawn%20no%20people%20empty%20space%20architectural%20photography%20high%20end%20property&width=1000&height=600&seq=paisagismo-luxury-backyard-1&orientation=landscape"
              alt="Paisagismo Decorativo"
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B4D3E]/70 via-[#1B4D3E]/30 to-transparent" />

            <div className="absolute bottom-0 left-0 right-0 p-12 max-lg:p-6">
              <div className="w-16 h-16 rounded-full bg-white flex items-center justify-center mb-6">
                <i className="ri-plant-line text-[#1B4D3E] text-3xl"></i>
              </div>
              <h3 className="font-cinzel font-semibold text-white text-4xl mb-6">
                Paisagismo Decorativo
              </h3>
              <ul className="space-y-3 mb-8">
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-[#C5A059] text-xl"></i>
                  <span className="font-montserrat text-white text-base">
                    Jardins Residenciais de Alto Padrão
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-[#C5A059] text-xl"></i>
                  <span className="font-montserrat text-white text-base">
                    Áreas Comuns de Condomínios
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-[#C5A059] text-xl"></i>
                  <span className="font-montserrat text-white text-base">
                    Academias e Colégios
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <i className="ri-checkbox-circle-fill text-[#C5A059] text-xl"></i>
                  <span className="font-montserrat text-white text-base">
                    Projetos Arquitetônicos Exclusivos
                  </span>
                </li>
              </ul>
              <button
                onClick={scrollToContact}
                className="inline-flex items-center gap-2 border-2 border-white text-white font-montserrat font-semibold text-sm uppercase px-8 py-3 rounded-full hover:bg-white hover:text-[#1B4D3E] transition-all whitespace-nowrap cursor-pointer"
              >
                Ver Projetos
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </motion.div>

          <div className="w-[42%] flex flex-col gap-10 max-lg:w-full max-lg:gap-8">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative h-[280px] rounded-xl overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.15)] group cursor-pointer max-lg:h-[320px]"
            >
              <img
                src="https://readdy.ai/api/search-image?query=premium%20private%20training%20ground%20society%20football%20field%20with%20perfectly%20manicured%20green%20synthetic%20artificial%20turf%20modern%20LED%20lighting%20poles%20along%20the%20sides%20small%20scale%20intimate%20pitch%20white%20line%20markings%20luxury%20sports%20facility%20night%20evening%20atmosphere%20no%20massive%20stadium%20structure%20high%20end%20attainable%20look%20architectural%20photography&width=700&height=280&seq=campos-society-training-ground-3&orientation=landscape"
                alt="Campos Esportivos"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-[#2D2D2D]/50" />

              <div
                className="absolute top-4 right-4 bg-[#C5A059] text-white font-montserrat font-semibold text-xs uppercase px-4 py-2 rounded-full"
                translate="no"
              >
                <span className="notranslate">FIFA Quality</span>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-8 max-lg:p-6">
                <h3 className="font-cinzel font-semibold text-white text-3xl mb-4">
                  Campos Esportivos
                </h3>
                <ul className="space-y-2">
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                    <span className="font-montserrat text-white text-sm">
                      Futebol Profissional
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                    <span className="font-montserrat text-white text-sm">
                      <span translate="no" className="notranslate">
                        Campo&nbsp;Society
                      </span>
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                    <span className="font-montserrat text-white text-sm">
                      Certificação Internacional
                    </span>
                  </li>
                </ul>
                <button
                  onClick={scrollToContact}
                  className="inline-flex items-center gap-2 border-2 border-white text-white font-montserrat font-semibold text-sm uppercase px-8 py-3 rounded-full hover:bg-white hover:text-[#1B4D3E] transition-all whitespace-nowrap cursor-pointer mt-6"
                >
                  Saiba Mais
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.2, duration: 0.8 }}
              className="relative h-[280px] rounded-xl overflow-hidden shadow-[0_12px_40px_rgba(0,0,0,0.15)] group cursor-pointer max-lg:h-[320px]"
            >
              <img
                src="https://readdy.ai/api/search-image?query=aerial%20view%20professional%20outdoor%20tennis%20court%20with%20vibrant%20green%20synthetic%20turf%20surface%20surrounded%20by%20padel%20courts%20modern%20sports%20complex%20facility%20bright%20sunny%20day%20high%20resolution%20architectural%20photography%20premium%20athletic%20center%20no%20people&width=700&height=280&seq=quadras-poli-tennis-padel-aerial-2&orientation=landscape"
                alt="Quadras Poliesportivas"
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-black/35" />

              <div className="relative h-full flex flex-col justify-center p-8 max-lg:p-6">
                <div className="w-16 h-16 rounded-full bg-[#C5A059]/20 backdrop-blur-sm flex items-center justify-center mb-6">
                  <i className="ri-tennis-line text-[#C5A059] text-3xl"></i>
                </div>
                <h3 className="font-cinzel font-semibold text-white text-3xl mb-4">
                  Quadras Poliesportivas
                </h3>
                <ul className="space-y-2 mb-6">
                  {['Tênis', 'Padel'].map((item) => (
                    <li key={item} className="flex items-center gap-2">
                      <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                      <span className="font-montserrat text-white text-sm">{item}</span>
                    </li>
                  ))}
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                    <span className="font-montserrat text-white text-sm">
                      <span translate="no" className="notranslate">
                        Rugby
                      </span>
                    </span>
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-fill text-[#C5A059] text-lg"></i>
                    <span className="font-montserrat text-white text-sm">Golfe</span>
                  </li>
                </ul>
                <button
                  onClick={scrollToContact}
                  className="inline-flex items-center gap-2 border-2 border-white text-white font-montserrat font-semibold text-sm uppercase px-8 py-3 rounded-full hover:bg-white hover:text-[#1B4D3E] transition-all whitespace-nowrap cursor-pointer"
                >
                  Saiba Mais
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
